export default __webpack_public_path__ + "static/share-image-97548b852cb197cc2a4863ce63024995.png";